import { QueryKey, useQuery } from "react-query";
import getReInspectionPreviousInspections from "../../api/inspections/getReInspectionPreviousInspections";
import useNetworkHeaders from "../../../../hooks/useNetworkHeaders";

interface IUseInspectionPreviousInspections {
  id: string | number;
}
export default function useInspectionPreviousInspections({ id }: IUseInspectionPreviousInspections) {
  const headers = useNetworkHeaders();
  const key = InspectionPreviousInspectionsQueryKey(id);
  const query = useQuery(key, getReInspectionPreviousInspections(headers, Number(id)));

  return {
    data: query.data,
    isLoading: query.isLoading,
    isFetching: query.isFetching,
  };
}

export function InspectionPreviousInspectionsQueryKey(id: string | number): QueryKey {
  return ["previous-inspections", id.toString()];
}
